import appConfig from "config/appConfig";

import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { LocalisationEntities, SupportedLanguages } from "shared/types/Localisation";

const namespaces = [LocalisationEntities.COMMON, LocalisationEntities.DATE, LocalisationEntities.ERROR];

i18n
	.use(HttpBackend)
	.use(initReactI18next)
	.init({
		lng: SupportedLanguages.ENGLISH,
		debug: appConfig.GLOBAL_CONSTANTS.ENV_STAGE === "dev" || appConfig.GLOBAL_CONSTANTS.ENV_STAGE === "local",
		fallbackLng: SupportedLanguages.ENGLISH,
		ns: namespaces,
		defaultNS: namespaces[0],
		interpolation: {
			escapeValue: false
		},
		react: {
			useSuspense: true
		},
		initImmediate: false,
		ignoreJSONStructure: false,
		backend: {
			loadPath: "/assets/i18n/{{lng}}/{{ns}}.json",
			referenceLng: SupportedLanguages.ENGLISH
		}
	});

export const changeLanguage = async (lng: SupportedLanguages) => {
	await i18n.changeLanguage(lng);
};

export default i18n;
